module.exports = __webpack_public_path__ + "img/image-file (SVG).15d1de14.svg";